import { render, staticRenderFns } from "./InstantCreditReturn.vue?vue&type=template&id=6e60f351"
import script from "./InstantCreditReturn.vue?vue&type=script&setup=true&lang=js"
export * from "./InstantCreditReturn.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports